export const url = {
  getFundraisers: "api/FundRaiser/FundRaisers",
  deleteFundraiser: "api/FundRaiser/Delete",
  copyFundraiser: "api/FundRaiser/Copy",
  createFundraiser: "api/FundRaiser/Create",
  updateFundraiser: "api/FundRaiser/Update",
  getDonationInsights: "api/FundRaiser/DonationInsights",
  getDashboardData: "api/FundRaiser/Dashboard",
  getFundraiserData: "api/FundRaiser/FundRaiserPublicView",
  getPromoters: "api/FundRaiser/Promoters",
  getDonations: "api/FundRaiser/Donations",
  getSubscriptions: "api/FundRaiser/RecurringDonations",
  exportDonations: "api/FundRaiser/ExportDonations",
  exportDonors: "api/FundRaiser/ExportDonors",
  getGallerySettings: "api/FundRaiser/GetGallery",
  updateGallerySettings: "api/FundRaiser/UpdateGalllery",
  saveGallerySettings: "api/FundRaiser/SaveGallery",
  getGalleries: "api/FundRaiser/GetGalleries",
  updateGalleryURL: "api/FundRaiser/UpdateGalleryURL",
  getPublicGallery: "api/FundRaiser/GetGalleryByURL",
  getDonationItems: "api/Donation/Donations",
  getMerchantAccounts: "api/MerchantAccounts/MerchantAccounts",
  getMindMeListInterestTag: "api/ListInterestTag/GetMindMeListInterestTag",
  updateFundraiserStatus: "api/FundRaiser/UpdateStatus",
  updateFundraiserPageName: "api/FundRaiser/UpdatePageName",
  getCategories: "api/Category/Categories",
  getPromoterDashboardData: "api/FundRaiser/GetPromoterDashboard",
  getMindMeContactReferences: "api/Contact/GetMindMeContactReferences",
  getFundraiserByUrl: "api/FundRaiser/GetFundRaisersByURL",
  refundPayment: "api/PaymentTransactions/Refund",
  addNewPromoterToFundRaiser: "api/FundRaiser/AddPromoter",
  addNewPromoters: "api/FundRaiser/AddPromoters",
  updateDonationDetails: "api/PaymentTransactions/UpdateDonationPayment",
  updatePromoter: "api/FundRaiser/UpdatePromoter",
  updatePromoters: "api/FundRaiser/UpdatePromoters",
  getMindMeMobilePages: "api/FundRaiser/GetMindMeMobilePages",
  getAllDonationItems: "api/Donation/GetDonationItems",
  updateMediaTitleAndDescription:
    "api/FundRaiser/UpdateMediaTitleAndDescription",
  saveOpenAISettings: "api/FundRaiser/SaveOpenAISettings",
  updateOpenAISettings: "api/FundRaiser/UpdateOpenAISettings",
  getOpenAISettings: "api/FundRaiser/GetFundRaiserOpenAISettings",
  downloadMediaToLibrary: "api/AccountMedia/DownloadMediaToLibrary",
  cancelSubscription: "api/Subscription/Cancel",
  getAccountBusinessInfo: "api/Account/GetAccountBusinessInfo",
  getReceiptDetails: "api/Account/GetReceiptDetails",
};
